import { createFileRoute } from '@tanstack/react-router';

// relative imports
import Loader from '../../../../../../components/shared/custom-components/Loader';
import SourceAudit from '../../../../../../components/source-management/reconciliation/SourceAudit';

export const Route = createFileRoute(
  '/_authenticated/(sources)/wallets/$walletId/_wallet/reconciliation',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: SourceAudit,
  beforeLoad: () => ({ sourceType: 'wallet' }),
});
